const appPrefix = 'humanagro-'

const CookiesKeys = {
  language: appPrefix + 'language',
  token: appPrefix + 'token',
}

export default CookiesKeys
